/**
 * Màn hình lỗi cấp route — `errorElement` của React Router.
 *
 * App Router không có `error.tsx` nào trong repo, nên hiện lỗi render sẽ rơi vào
 * overlay mặc định của Next ở dev và trang lỗi trắng ở production. SPA không có
 * lưới đỡ nào cả: một lỗi render không bắt được sẽ xoá sạch cây React và để lại
 * màn hình trắng hoàn toàn, nên phần này là bắt buộc chứ không phải điểm cộng.
 *
 * Cố ý giữ đơn giản và không phụ thuộc gì ngoài React Router: component này
 * phải render được ngay cả khi thứ vừa hỏng là provider hoặc theme.
 */

import { isRouteErrorResponse, useRouteError } from 'react-router';

export function RouteError() {
  const error = useRouteError();

  let title = 'Đã xảy ra lỗi';
  let detail = 'Vui lòng tải lại trang. Nếu vẫn lỗi, báo bộ phận kỹ thuật.';

  if (isRouteErrorResponse(error)) {
    title = `Lỗi ${error.status}`;
    detail = error.statusText || detail;
  } else if (error instanceof Error) {
    detail = error.message;
  }

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background px-6 text-center">
      <h1 className="text-2xl font-semibold text-foreground">{title}</h1>
      <p className="max-w-md text-muted-foreground">{detail}</p>
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="rounded-md bg-primary px-4 py-2 text-primary-foreground"
      >
        Tải lại trang
      </button>
    </div>
  );
}
